import { BodyList, Header } from "./orderPart";

export const NormalOrder = ({ orderData, handleAllStateOrderData, handleStateOrderData }) => (
  <>
    <Header orderData={orderData} handleAllStateOrderData={handleAllStateOrderData} />
    <div className="orderBody">
      {orderData?.products?.map((product, ingredientIndex) => (
        <BodyList
          ingredient={product}
          ingredientIndex={ingredientIndex}
          key={product.orderProductId || ingredientIndex}
          handleStateOrderData={handleStateOrderData}
        />
      ))}
    </div>
    {orderData.notes && orderData.notes.length > 0 && (
      <div className="orderItemNotes text-align-center">
        *<em>{orderData.notes}</em>*
      </div>
    )}
  </>
);
